/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import ReactResizeDetector from 'react-resize-detector';
import { uniqueId } from 'lodash';
import { Line as ProgressBar } from 'rc-progress';
import _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { makeSelectStep12 } from './selectors';
import reducer from './reducer';

import { Button } from '../components/Button';
import Section from '../components/Section';

import {
  removeFile,
  resetFormData,
  uploadFile,
} from './actions';

import { AttachSupportingDocuments } from './components/AttachSupportingDocuments';
import { saveFormData } from '../actions';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import AsyncButton from '../../../components/AsyncButton';
import ModalError from './components/ModalError';
import { makeSelectStep5 } from '../Step5/selectors';
import Step6Shared from '../Step6/components/Step6Shared';
import Step7Shared from '../Step7/components/Step7Shared';
import Step8Shared from '../Step8/components/Step8Shared';
import Step9Shared from '../Step9/Step9Shared';
import Step11Shared from '../Step11/components/Step11Shared';
import {
  step11ExpenseLookup,
  step6ExpenseLookup,
  step7ExpenseLookup,
  step8ExpenseLookup,
  step9ExpenseLookup,
} from '../dataMapper/claimCodeMapper';
import P from '../../../components/P';

export class Step12 extends React.Component {
  constructor(props) {
    super(props);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;

    this.state = {
      invalidFileName: false,
      isLongFileName: false,
    };

    this.onResize = this.onResize.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.checkFileNameLength = this.checkFileNameLength.bind(this);
    this.onAttachDocumentChange = this.onAttachDocumentChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  componentWillUpdate() {
    if (this.props.adjust) {
      // this is a workaround to ensure we refresh the UI
      // to render the list of attachments.
      this.props.adjust();
    }
  }

  onResize() {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  }

  onAttachDocumentChange(benefitCode, files) {
    const { onFileUpload } = this.props;
    const file = files ? files[0] : {};
    if (this.checkFileNameLength(file)) {
      this.setState({ isLongFileName: true }, () => {
        this.showModal();
      });
    } else if (this.checkFileExist(file)) {
      this.setState({ isLongFileName: false }, () => {
        this.showModal();
      });
    } else {
      onFileUpload(files, benefitCode);
    }
  }

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  handleNext = () => {
    this.props.onFormDataSave();
    this.props.next();
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  showModal() {
    this.setState({ invalidFileName: true });
  }

  hideModal() {
    this.setState({ invalidFileName: false });
  }

  checkFileNameLength(file) {
    if (file.name && file.name.length > 50) {
      return true;
    }
    return false;
  }

  checkFileExist = (file) => {
    if (this.props.form.attachDocuments.length) {
      return this.props.form.attachDocuments.filter((f) => f.name === file.name).length > 0;
    }
    return false;
  };
  renderUploadAreaForBenefits = (attachDocuments, onAttachDocumentChange, onFileRemove, isReadOnly) => {
    // Overseas Medical Step 8
    // Trip Cancellation step 6
    // Personal Items Step 7
    // Other Documents step 11
    const { selectedBenefits } = this.props.step5Data;
    const list = [...(!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || [])];
    if (!list.length) {
      return null;
    }

    // need to reorder list
    for (let x = 0; x < list.length; x++) {
      if (((step8ExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 1;
      } else if (((step6ExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 3;
      } else if (((step7ExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 2;
      } else if (((step11ExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 5;
      } else if ((Object.values(step9ExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 4;
      }
    }
    return _.orderBy(_.uniqBy(list, 'step'), ['order'], ['asc']).map((d, idx) => (
      <div key={idx} style={{ backgroundColor: '#f5f5f5', marginLeft: '5px', marginRight: '5px' }} className={idx > 0 ? 'row pt-3 mt-4' : 'row pt-3'}>
        <div className="form-group col-md-12">
          <b>{d.description} Documents</b> - Provide all that are relevant to your claim
          </div>
        <div style={{ paddingRight: '15px' }}>
          {d.order === 3 && <Step6Shared />}
          {d.order === 2 && <Step7Shared />}
          {d.order === 1 && <Step8Shared />}
          {d.order === 4 && <Step9Shared />}
          {/* {d.order === 6 && <Step10Shared />} */}
          {d.order === 5 && <Step11Shared />}
        </div>
        <div className="form-group col-md-12">
          <AttachSupportingDocuments
            claimCode={d.claimCode}
            data={attachDocuments}
            onChange={onAttachDocumentChange.bind(this, d.claimCode)}
            onDelete={onFileRemove}
            disabled={isReadOnly}
          />
        </div>
      </div>

      ));
  };

  render() {
    const {
      attachDocuments,
      uploadPercentage,
      progressBarVisibility,
    } = this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isReadOnly = submitted || isSummary;
    const { invalidFileName, isLongFileName } = this.state;
    return (
      <div className="app-content">

        <Section className="text-center">
          <P className="mb-0">We can assess claims quicker if we receive all the required documentation. Please review the list below and provide the documents that are relevant to your claim.</P>
        </Section>
        <Section>
          <ProgressBar
            percent={uploadPercentage}
            style={{ display: progressBarVisibility ? '' : 'none' }}
            trailColor="#D9D9D9"
            strokeColor="#2db7f5"
          />
        </Section>
        {this.renderUploadAreaForBenefits(attachDocuments, this.onAttachDocumentChange, this.props.onFileRemove, isReadOnly)}
        {!isSummary && (
          <div className={'row justify-content-between mt-3'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    disabled={progressBarVisibility}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    disabled={progressBarVisibility}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  disabled={progressBarVisibility}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
        <ModalError isLongFileName={isLongFileName} isOpen={invalidFileName} onClose={this.hideModal} />
      </div>
    );
  }
}

Step12.propTypes = {
  form: PropTypes.object,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFileUpload: PropTypes.func,
  onFileRemove: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  onFormDataSave: PropTypes.func,
  step5Data: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStep12(),
  loading: makeSelectProgressBarStatus(),
  step5Data: makeSelectStep5(),
});

const mapDispatchToProps = (dispatch) => ({
  onFileUpload: (files, benefitCode) => dispatch(uploadFile(files, benefitCode)),
  onFileRemove: (file) => dispatch(removeFile(file)),
  onFormDataSave: () => dispatch(saveFormData()),
  onReset: () => {
    dispatch(resetFormData());
  },
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'step12', reducer });

export default compose(
  withReducer,
  withConnect
)(Step12);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step12/index.js